// guest-entry.ts — ASK-172 Client 5b item 1: the ANONYMOUS DEV ENTRY (Shaun's rule, ASK-159 §2.18hy: guests READ ONLY, dev
// only, never Live). A meet link (`?shop=<id>&meet=<token>`) followed without an account may continue as a GUEST only where
// the plane's PUBLIC door says `presence.anonymousMayFollow` (dev true · prod false) — read from the door every time, never
// assumed from the plane. A guest is a Firebase anonymous uid: it arrives through the meet path as the mannequin, reads the
// party's thread, cannot mint, cannot send ("Sign in to chat"). With the door false the gate never offers it, and an
// anonymous session that somehow exists is signed out to the gate.

// `_party-core.js` (the token grammar) is imported LAZILY: the gate asks only on a page that carries a link, so no
// shopper's first paint carries it (the customer initial bundle budget, check-bundle-budget).
const core = () => import("@runtime/_party-core.js");

const PARTY_KEY = "kapowx_party";   // `_party.js` keeps the party a session belongs to (a reload picks it back up)
// ALPHA012 step 4 (Client 5d item 0): the link this TAB entered as a guest through. The meet arrival strips `meet=` from the
// URL once read and stores the party only after its join answers — between the two (and after a party that never formed)
// the tab carried NO trace of the link, so any re-judge (a reload; a second auth event, e.g. another tab of the profile)
// read "no link", signed the guest out and showed the signed-out splash. Stashed at the gate's click (before the reload)
// and on a guest mount; cleared on sign-out.
const GUEST_KEY = "kapowx_guest_meet";
export function stashGuestToken(token: string | null): void {
	try { if (token) sessionStorage.setItem(GUEST_KEY, token); else sessionStorage.removeItem(GUEST_KEY); } catch { /* private mode */ }
}

/** The party a guest would be following: the link's `meet` token, else the party this tab already joined. */
export async function guestLinkToken(search: string = typeof location !== "undefined" ? location.search : ""): Promise<string | null> {
	let stored: string | null = null;
	try { const s = JSON.parse(sessionStorage.getItem(PARTY_KEY) || "null"); stored = s && typeof s.token === "string" ? s.token : null; } catch { /* private mode */ }
	if (!stored) { try { stored = sessionStorage.getItem(GUEST_KEY); } catch { /* private mode */ } }
	if (!/[?&]meet=/.test(search) && !stored) return null;   // nothing to follow: never load the grammar
	const { meetTokenFrom } = await core();
	return meetTokenFrom(search) || (stored && meetTokenFrom(`?meet=${stored}`) ? stored : null);
}

let doorP: Promise<boolean> | null = null;
/** True only when the plane's public door answers `presence.enabled && presence.anonymousMayFollow` (absent = false). */
export function guestsMayFollow(): Promise<boolean> {
	if (doorP) return doorP;
	const gw: string | undefined = import.meta.env.VITE_GATEWAY_URL;
	if (!gw) return (doorP = Promise.resolve(false));
	doorP = fetch(`${gw.replace(/\/$/, "")}/api/kapowx/v1/auth/sign-in-methods`, { cache: "no-store" })
		.then((r) => (r.ok ? r.json() : null))
		.then((d) => d?.presence?.enabled === true && d?.presence?.anonymousMayFollow === true)
		.catch(() => false);
	return doorP;
}

/** May THIS page continue as a guest: a party to follow AND the door says so. */
export async function guestEntryAllowed(): Promise<boolean> {
	if (!(await guestLinkToken())) return false;
	return guestsMayFollow();
}
